<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="title">Add Contact</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="formCnt">
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Type</label>
                <select type="text" class="field" v-model="form.type.model">
                  <option>Phone</option>
                  <option>Email</option>
                  <option>Help Page</option>
                </select>
              </div>
            </div>
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Name</label>
                <input type="text" class="field" placeholder="Name..."
                  v-model="form.name.model">
              </div>
            </div>
            <template v-if="form.type.model === 'Phone'">
              <div class="fieldGroup">
                <div class="fieldCnt">
                  <label>Phone Number</label>
                  <input type="text" class="field" placeholder="Phone number..."
                    v-model="form.phone.model">
                </div>
              </div>
              <div class="fieldGroup fgWa">
                <div class="toggle"  v-on:click="form.isWhatsApp = !form.isWhatsApp">
                  <div class="radioItem" :class="{on: form.isWhatsApp}">
                    <div class="radioIn">
                      <div class="radioHandle"></div>
                    </div>
                    WhatsApp available?
                  </div>
                </div>
              </div>
            </template>
            <div class="fieldGroup fgWa" v-if="form.type.model === 'Email'">
              <div class="fieldCnt">
                <label>Email Address</label>
                <input type="text" class="field" placeholder="Email address..."
                  v-model="form.email.model">
              </div>
            </div>
            <div class="fieldGroup" v-if="form.type.model === 'Help Page'">
              <div class="fieldCnt">
                <label>Url</label>
                <input type="text" class="field" placeholder="https://..."
                  v-model="form.url.model">
                <div class="fieldHint">Paste help page url here</div>
              </div>
            </div>
          </div>
          <div class="btnCnt">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary">Save Contact</button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      form: {
        type: { model: 'Phone', error: null },
        name: { model: '', error: null },
        phone: { model: '', error: null },
        email: { model: '', error: null },
        url: { model: '', error: null },
        isWhatsApp: { model: true },
      },
    };
  },
  methods: {
    open(d, n) {
      this.form.type.model = (d && d.type) ? d.type : 'Phone';
      this.form.type.error = null;
      this.form.name.model = (d && d.name) ? d.name : '';
      this.form.name.error = null;
      this.form.phone.model = (d && d.phone) ? d.phone : '';
      this.form.phone.error = null;
      this.form.email.model = (d && d.email) ? d.email : '';
      this.form.email.error = null;
      this.form.url.model = (d && d.url) ? d.url : '';
      this.form.url.error = null;
      this.next = n;
      this.show = true;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    handleSubmit() {
      const formData = {
        type: this.form.type.model,
        name: this.form.name.model,
        phone: this.form.phone.model,
        email: this.form.email.model,
        url: this.form.url.model,
        isWhatsApp: this.form.isWhatsApp.model,
      };
      this.close(true, formData);
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.formCnt{
  position: relative;
}
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    padding: 24px 60px 40px;
    overflow: hidden;
    transition: all .3s ease;
    width: 320px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4.title{
      font-size: 24px;
      margin: 0;
      font-weight: normal;
      margin-bottom: 20px;
    }
    .fieldGroup.fgWa{
      margin-bottom: 30px;
    }
    .btnCnt{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -60px -40px;
      padding: 12px 30px 2px;
      &.saveDisabled{
        .btnPrimary{
          background-color: #ccc;
          color: #999;
          box-shadow: none;
          cursor: default;
        }
      }
    }
    .btn{
      margin-left: 5px;
      margin-bottom: 10px;
      &.saving{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none;
      }
    }
  }
}
</style>
